import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import * as XLSX from 'xlsx';
import {DialogSubscriptionComponent} from '../../dialog/dialog-subscription.component';
import {DialogService} from '../../dialog/dialog.service';
import {CourseCacheService} from '../../shared/course-cache.service';
import {CourseService} from '../../shared/course.service';
import {RosterLink} from '../../shared/interface/roster-link.interface';
import {EmailClassComponent} from '../email-class/email-class.component';
import {CourseDialogData} from '../roster.types';
import {ViewLogComponent} from '../view-log/view-log.component';
import {Roles} from "../../core/ucr-security/roles";
import {UserInfo} from "../../core/ucr-security/user-info";
import {UcrSecurityService} from "../../core/ucr-security/ucr-security.service";

@Component({
    selector: 'app-roster-roster-link',
    templateUrl: './roster-link.component.html',
    styleUrls: ['./roster-link.component.scss']
})
export class RosterLinkComponent extends DialogSubscriptionComponent implements OnInit {
    readonly roles = Roles;
    userInfo: UserInfo;

    constructor(
        private ucrSecurityService: UcrSecurityService,
        public courseService: CourseService,
        public courseCacheService: CourseCacheService,
        public route: ActivatedRoute,
        private dialogService: DialogService<CourseDialogData>
    ) {
        super();
        this.ucrSecurityService.getUserInfo().subscribe((ui: UserInfo) => {
            this.userInfo = ui;
        });

    }

    @Input() termCode: string;
    @Input() crn: string;
    rosterLinkList: Array<RosterLink> = [];

    fileName = '';
    today: number = Date.now();
    // @ts-ignore
    formattedDate: number = this.today | 'yyyy_MM_dd_HH_mm_ss';
    toDisplay: boolean = false;


    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        if (!this.termCode) {
            this.termCode = this.route.snapshot.paramMap.get('termCode');
        }
        if (!this.crn) {
            this.crn = this.route.snapshot.paramMap.get('crn');
        }
        if (!this.courseService.currentCourse) {
            this.courseCacheService.setCache(this.termCode, this.crn);
        }
    }

    exportexcel(): void {
        this.fileName =
            this.termCode +
            '_' +
            this.courseService.currentCourse.subjectCode +
            '_' +
            this.courseService.currentCourse.courseNumber +
            '_' +
            this.courseService.currentCourse.sectionNumber +
            '_CRN_(' +
            this.crn +
            ')_' +
            this.formattedDate +
            '.xlsx';

        /* pass here the table id */
        const element = document.getElementById('excel-table');
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
        delete ws['08'];

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.fileName);
    }

    printRoster(): void {
        let printContents, popupWin;
        // eslint-disable-next-line prefer-const
        printContents = document.getElementById('roster-table').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`);
        popupWin.document.close();
    }

    viewLog() {
        this.dialogService.show(
            {
                termCode: this.termCode,
                crn: this.crn,
                readonly: false
            },
            {
                component: ViewLogComponent,
                dialogAlias: 'view_log',
                title: this.currentCourseTitle(),
                uniqueId: `view_log_${this.courseService.currentCourse.crn}`
            }
        );
    }

    private currentCourseTitle(): string {
        return `${this.courseService.currentCourse?.courseTitle} [${this.courseService.currentCourse?.displayCourseString}] (CRN: ${this.courseService.currentCourse?.crn}) - ${this.courseService.currentCourse?.termCodeDescription}`;
    }

    openHelp() {
        window.open('https://registrar.ucr.edu/resources/igrade', '_blank');
    }

    emailClass() {
        this.dialogService.show(
            {
                termCode: this.termCode,
                crn: this.crn,
                readonly: false
            },
            {
                component: EmailClassComponent,
                dialogAlias: 'email_class',
                title: this.currentCourseTitle(),
                uniqueId: `email_class_${this.courseService.currentCourse.crn}`
            }
        );
    }
}
